import React from 'react';

interface EmojisBoxProps {
    emojis: string[]; // define a prop for the list of emojis
    /** While AOTD guessing hides the emojis: draw this many "?" instead. */
    hiddenCount?: number;
    /** Tapping the "?" box takes you down to the guessing. */
    onHiddenClick?: () => void;
}

const BOX_CLASS = "absolute text-[22px] md:text-2xl leading-none bottom-[-2px] right-[-3px] bg-gray-100 p-1 px-1 flex gap-1 shadow-indigo-400 shadow-sm rounded-sm";

const EmojisBox: React.FC<EmojisBoxProps> = ({ emojis, hiddenCount, onHiddenClick }) => {

    if (hiddenCount && hiddenCount > 0) {
        return (
            <button
                type="button"
                onClick={onHiddenClick}
                className={`${BOX_CLASS} cursor-pointer`}
                aria-label="The emojis are hidden while AOTD guessing runs. Go to the guessing."
                title="guess them below"
            >
                {Array.from({ length: Math.min(hiddenCount, 3) }, (_, index) => (
                    <span key={index} aria-hidden="true" className="inline-block text-center font-bold" style={{ width: '1em', color: '#b4532a' }}>?</span>
                ))}
            </button>
        );
    }

    if (emojis.length === 0) {
        return null;
    }

    return (
        <div className={BOX_CLASS}>
            {emojis.slice(0, 3).map((emoji, index) => (
                <span key={index} role="img" aria-label={`emoji-${index}`}>{emoji}</span>
            ))}
        </div>
    );
};

export default EmojisBox;
